import { useNavigate } from 'react-router';
import { useApiContext } from 'react-easyrocket';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';
import { useRoute } from 'src/router/hooks/useRoute';

export const ProtectedAuthRoute = ({ children }: { children: JSX.Element }) => {
  const navigate = useNavigate();
  const { ROUTE } = useRoute();
  const { startRegistration } = useAuthFlow();
  const { isAuthenticated } = useApiContext();

  if (isAuthenticated) {
    return children;
  } else {
    navigate(ROUTE.MAIN.get());
    startRegistration({ replace: true });
  }
  return <></>;
};
